import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { BulkProgressModalProps } from './BulkProgressModal.types';
import * as docuMateConstant from '../util/docuMateConstant';
import './BulkProgressModal.scss';

const BulkProgressModal: React.FC<BulkProgressModalProps> = ({
    show,
    title,
    current,
    total,
    successCount,
    failureCount,
    successFileNames = [],
    failureFileNames = [],
    isProcessing,
    isComplete,
    onComplete,
    processingTitle,
    completeTitle,
    processingMessage
}) => {
    const progressPercent = total > 0 ? (current / total) * 100 : 0;
    const resolvedProcessingTitle = processingTitle || docuMateConstant.BULK_REDIRECT_PROCESSING_TITLE;
    const resolvedCompleteTitle = completeTitle || docuMateConstant.BULK_REDIRECT_COMPLETE_TITLE;
    const resolvedProcessingMessage = processingMessage || docuMateConstant.BULK_REDIRECT_PROCESSING_MESSAGE;

    return (
        <Modal
            show={show}
            centered
            backdrop="static"
            keyboard={false}
            onHide={() => {}}
            className="bulk-progress-modal"
            backdropClassName="bulk-progress-modal-backdrop"
        >
            <Modal.Header className="modalHeader">
                <Modal.Title>{isComplete ? resolvedCompleteTitle : isProcessing ? resolvedProcessingTitle : title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {isProcessing && (
                    <>
                        <p>{resolvedProcessingMessage} <strong>{current}/{total}</strong></p>
                        <div className="bulk-progress-bar-container">
                            <div className="bulk-progress-bar-fill" style={{ width: `${progressPercent}%` }} />
                        </div>
                    </>
                )}
                {isComplete && (
                    <>
                        <p><strong>{resolvedCompleteTitle}</strong></p>
                        <p className="bulk-progress-success">Successful: {successCount}</p>
                        {successFileNames.length > 0 && (
                            <div className="bulk-progress-file-list bulk-progress-success-list">
                                <ul>
                                    {successFileNames.map((fileName) => (
                                        <li key={`success-${fileName}`}>{fileName}</li>
                                    ))}
                                </ul>
                            </div>
                        )}
                        {failureCount > 0 && (
                            <>
                                <p className="bulk-progress-failure">Failed: {failureCount}</p>
                                {failureFileNames.length > 0 && (
                                    <div className="bulk-progress-file-list bulk-progress-failure-list">
                                        <ul>
                                            {failureFileNames.map((fileName) => (
                                                <li key={`failed-${fileName}`}>{fileName}</li>
                                            ))}
                                        </ul>
                                    </div>
                                )}
                            </>
                        )}
                    </>
                )}
            </Modal.Body>
            {isComplete && (
                <Modal.Footer>
                    <Button variant="primary" size="sm" onClick={onComplete}>OK</Button>
                </Modal.Footer>
            )}
        </Modal>
    );
};

export default BulkProgressModal;
